module.exports = flarum.core.compat['helpers/avatar'];